import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetFeaturesUserManualLink,
	GetFeaturesUserManualLinkModel,
} from 'domain/usecases/private/external-links/user-manual/get-features-user-manual';

export class RemoteGetFeaturesUserManualLink implements GetFeaturesUserManualLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetFeaturesUserManualLinkModel>,
	) {}

	async get(): Promise<GetFeaturesUserManualLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
